import { useEffect, useState } from "react";
import general from "../../general";
import { Link } from "react-router-dom";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import useUrlState from "@ahooksjs/use-url-state";
import Subtitle from "../components/Subtitle";
import ChatList from "../components/chatList/ChatList";
import ShareAlert from "../components/alert/ShareAlert";

export default props => {
  const [article, setArticle] = useState({});
  const [game, setGame] = useState({});
  const [params, setParams] = useUrlState({}, { navigateMode: 'replace' });
  const [init, setInit] = useState(false);
  useEffect(() => {
    setGame(general.game);
  }, []);
  useEffect(() => {
    Dialog.loading();
    general.axios.post('/base/news/getNewsDetail', { news_id: props.query.id })
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        setInit(true);
        let result = /<body[^>]*?>([\s\S]*)<\/body>/g.exec(data.news_info.content);
        if (result && result[1]) {
          data.news_info.content = result[1];
        }
        setArticle(data.news_info);
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  }, []);
  useEffect(() => {
    if (article) {
      if (params.type == 'raiders') {
        props.setTitle('攻略详情');
      } else {
        props.setTitle('活动详情');
      }
      // props.setTitle(article.title);
    }
  }, [article]);

  // console.log(params);

  const [visible, setVisible] = useState(false)
  useEffect(() => {
    props.setOperate(<img src="resources/share.png" height={22} onClick={()=>setVisible(true)} alt=""/>)
  },[])
  return init ?
    <div className="article-detail" style={{padding:'15px',backgroundColor:'#f5f6f8'}}>

      {article?.themeType == 2 ?
        <>
          <div className="contentItems">
            {
              article?.contentItems.map((item, index) =>
                item.type == 2 ?
                  <div className="contentitem" dangerouslySetInnerHTML={{ __html: item.content || null }} />
                  :
                  <div className="contentitem">
                    <div className="title">{item.title}</div>
                    <div className="contenttext">{item.content}</div>
                  </div>
              )
            }
          </div>
        </>
        :
        <>
          <div className="article">
            <div className="content" dangerouslySetInnerHTML={{ __html: article.content}} />
          </div>
        </>
      }

      <div className="article-footer">
        {
          article?.wechatWorkUrl ?
            <div className="article-operate" onClick={() => window.location.href = article.wechatWorkUrl}>联系客服</div>
            :
            <Link to={"/service"} className="article-operate">
              联系客服
            </Link>
        }
      </div>
      <div style={{ height: "70px",color:"transparent" }}></div>
      {visible && <ShareAlert close={()=>setVisible(false)} topic_id={article.maiyou_gameid} shareUrl={article?.share_url} visible={visible} id={article?.id} subtype={article?.subtype}></ShareAlert>}
      {/* <div className="view-end">别撩啦！已经到底啦~</div> */}
    </div>
    : null;
};